<!-- @format -->
<template>
    <div class="account-gateway-view">
        <div class="h-container-fluid">
            <div class="h-row">
                <div class="h-col-md-7">
                    <account-gateway
                        :isConnectwise="isConnectwise"
                        :isConnectwiseElevated="isConnectwiseElevated"
                        :isChartec="isChartec"
                        :isBitdefender="isBitdefender"
                        :isSophos="isSophos"
                        :isBarracuda="isBarracuda"
                        :isExclusiveNetworks="isExclusiveNetworks"
                        :isFortMesa="isFortMesa"
                        :isSentinelOne="isSentinelOne"
                        :isTDSynnex="isTDSynnex"
                        :isTDSynnexDynamics="isTDSynnexDynamics"
                    />
                </div>
                <div class="h-col-md-5 graphic-column">
                    <div v-if="isConnectwisePartnerProgram" class="background">
                        <img src="@/assets/images/cw-logos-design.png" />
                    </div>
                    <connectwise-carousel v-else-if="isConnectwise" />
                    <connectwise-elevated-carousel v-else-if="isConnectwiseElevated" />
                    <chartec-carousel v-else-if="isChartec" />
                    <bitdefender-carousel v-else-if="isBitdefender" />
                    <sophos-carousel v-else-if="isSophos" />
                    <barracuda-carousel v-else-if="isBarracuda" />
                    <exclusive-networks-carousel v-else-if="isExclusiveNetworks" />
                    <fort-mesa-carousel v-else-if="isFortMesa" />
                    <sentinelone-carousel v-else-if="isSentinelOne" />
                    <tdsynnex-carousel v-else-if="isTDSynnex || isTDSynnexDynamics" :is-td-synnex-dynamics="isTDSynnexDynamics" />
                    <account-carousel v-else />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const AccountGateway = () => import('@/components/account/account-gateway');
const AccountCarousel = () => import('@/components/account/account-carousel');
const ConnectwiseCarousel = () => import('@/components/account/connectwise-carousel');
const ConnectwiseElevatedCarousel = () =>
    import('@/components/account/connectwise-elevated-carousel');
const ChartecCarousel = () => import('@/components/account/chartec-carousel');
const BitdefenderCarousel = () => import('@/components/account/bitdefender-carousel');
const SophosCarousel = () => import('@/components/account/sophos-carousel');
const BarracudaCarousel = () => import('@/components/account/barracuda-carousel');
const ExclusiveNetworksCarousel = () => import('@/components/account/exclusive-networks-carousel');
const FortMesaCarousel = () => import('@/components/account/fort-mesa-carousel');
const SentinelOneCarousel = () => import('@/components/account/sentinelone-carousel');
const TDSynnexCarousel = () => import('@/components/account/tdsynnex-carousel');

export default {
    components: {
        'account-gateway': AccountGateway,
        'account-carousel': AccountCarousel,
        'connectwise-carousel': ConnectwiseCarousel,
        'connectwise-elevated-carousel': ConnectwiseElevatedCarousel,
        'chartec-carousel': ChartecCarousel,
        'bitdefender-carousel': BitdefenderCarousel,
        'sophos-carousel': SophosCarousel,
        'barracuda-carousel': BarracudaCarousel,
        'exclusive-networks-carousel': ExclusiveNetworksCarousel,
        'fort-mesa-carousel': FortMesaCarousel,
        'sentinelone-carousel': SentinelOneCarousel,
        'tdsynnex-carousel': TDSynnexCarousel,
    },

    computed: {
        isConnectwise() {
            return this.$route.name === 'AccountSignupCW';
        },

        isConnectwiseElevated() {
            return this.$route.name === 'AccountSignupCwElevated';
        },

        isConnectwisePartnerProgram() {
            return this.$route.name === 'PartnerProgramCW';
        },

        isChartec() {
            return this.$route.name === 'AccountSignupChartec';
        },

        isBitdefender() {
            return this.$route.name === 'AccountSignupBitdefender';
        },

        isSophos() {
            return this.$route.name === 'AccountSignupSophos';
        },

        isBarracuda() {
            return this.$route.name === 'AccountSignupBarracuda';
        },

        isExclusiveNetworks() {
            return this.$route.name === 'AccountSignupExclusiveNetworks';
        },

        isFortMesa() {
            return this.$route.name === 'AccountSignupFortMesa';
        },

        isSentinelOne() {
            return this.$route.name === 'AccountSignupSentinelOne';
        },

        isTDSynnex() {
            return this.$route.name === 'AccountSignupTDSynnex';
        },

        isTDSynnexDynamics() {
            return this.$route.name === 'AccountSignupTDSynnexDynamics';
        },
    },

    data() {
        return {};
    },
};
</script>

<style>
.account-gateway-view {
    padding: 0;
    background: #fff;
    overflow-y: hidden;
}

.account-gateway-view .graphic-column .background {
    background-image: url('../../assets/images/Background.png');
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

.account-gateway-view .graphic-column .background img {
    max-width: 637px;
    height: auto;
    width: 90%;
}

.account-gateway-view .graphic-column {
    padding: 0;
}

.account-gateway-view {
    height: 100%;
}

@media (max-width: 768px) {
    .account-gateway-view .account-gateway {
        width: 100%;
        padding: 0;
    }
}
</style>
